export default __webpack_public_path__ + "static/media/dj.89d8376e.svg";